<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-5 p-0">
            <!-- <div class="signupimage-height image-height">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" class="img-fluid" alt="" srcset="">

                </div>
            </div> -->
            <div class="image-height" [ngClass]="getBackgroundClass()">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" class="img-fluid" alt="" srcset="">

                </div>
            </div>
        </div>
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header justify-content-end">
                    <h5 class="m-0">{{ 'HAVE_ACCOUNT' | translate}}&nbsp;<a [href]="isPartnerFlow ? 'login?userType=5' : 'login'" class="fw-medium">{{ 'SIGN_IN'
                            | translate}}!</a></h5>
                    <b>-</b>
                    <h5 class="m-0"><a href="faq-page" class="fw-medium">{{ 'HELP' | translate}}</a></h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-center mb-2">{{ 'SIGN_UP' | translate}}</h2>

                    <!-- Partner Info Banner -->
                    <div class="partner-info-banner" *ngIf="showPartnerBanner">
                        <div class="partner-info-banner__content">
                            <span class="material-symbols-outlined partner-info-banner__icon">verified</span>
                            <div class="partner-info-banner__details">
                                <span class="partner-info-banner__badge">{{ 'VERIFIED_PARTNER' | translate }}</span>
                                <span class="partner-info-banner__name">{{ 'REFERRED_BY' | translate }}: {{ partnerDisplayName }}</span>
                                <span class="partner-info-banner__ref">{{ partnerReferenceId }}</span>
                            </div>
                        </div>
                    </div>

                    <form *ngIf="signUpForm" class="login-form" [formGroup]="signUpForm" (ngSubmit)="form.form.valid"
                        #form="ngForm">
                        <label class="text-danger small">{{'CHECK_SPAM_MESSAGE' | translate}}</label>
                        <div class="dropdown-container" *ngIf="!isPartnerFlow">
                            <label for="signupRole">{{'SIGN_UP_AS' | translate}}</label>
                            <mat-form-field class="w-100 ">
                                <mat-select id="signupRole" formControlName="userTypeId">
                                    <mat-option *ngFor="let role of roles" [value]="role.value" [disabled]="role.disabled">
                                        {{
                                        role.text === 'Customer' ? ('CUSTOMER' | translate) :
                                        role.text === 'Firm/Agent' ? ('FIRM_AGENT' | translate) :
                                        role.text
                                        }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="mb-2 mt-2">
                            <mat-label>{{ 'EMAIL'|translate }} <span class="text-danger">*</span></mat-label>
                            <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_EMAIL' | translate"
                                formControlName="email">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || signUpForm.get('email')?.touched) && signUpForm.controls['email'].errors?.['required']">
                                {{'EMAIL_ADDRESS_REQUIRED' | translate}}
                            </mat-error>
                            <mat-error class="text-danger"
                                *ngIf="form.submitted && signUpForm.controls['email'].errors?.['pattern']">
                                {{'EMAIL_INVALID' | translate}}
                            </mat-error>
                        </div>

                        <!-- Customer Registration Fields -->
                        <div *ngIf="signUpForm.get('userTypeId')?.value === 2" class="customer-fields">
                            <div class="mb-2">
                                <mat-label>{{ 'FIRST_NAME'|translate }} <span class="text-danger">*</span></mat-label>
                                <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_FIRST_NAME' | translate"
                                    formControlName="firstName">
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('firstName')?.touched) && signUpForm.controls['firstName'].errors?.['required']">
                                    {{'FIRST_NAME_REQUIRED' | translate}}
                                </mat-error>
                            </div>
                            <div class="mb-2">
                                <mat-label>{{ 'LAST_NAME'|translate }} <span class="text-danger">*</span></mat-label>
                                <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_LAST_NAME' | translate"
                                    formControlName="lastName">
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('lastName')?.touched) && signUpForm.controls['lastName'].errors?.['required']">
                                    {{'LAST_NAME_REQUIRED' | translate}}
                                </mat-error>
                            </div>
                            <div class="mb-2">
                                <mat-label>{{ 'MOBILE_NUMBER'|translate }} <span class="text-danger">*</span></mat-label>
                                <input matInput class="mat-mdc-input-element w-100 form-control" [placeholder]="'ENTER_MOBILE_NUMBER' | translate"
                                    formControlName="mobileNumber" maxlength="12"
                                    (input)="onMobileNumberInput()">
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('mobileNumber')?.touched) && signUpForm.controls['mobileNumber'].errors?.['required']">
                                    {{'MOBILE_NUMBER_REQUIRED' | translate}}
                                </mat-error>
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('mobileNumber')?.touched) && signUpForm.controls['mobileNumber'].errors?.['pattern']">
                                    {{'MOBILE_NUMBER_INVALID' | translate}}
                                </mat-error>
                            </div>
                            <div class="mb-2">
                                <mat-label>{{ 'ZIP_CODE'|translate }} <span class="text-danger">*</span></mat-label>
                                <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="zipCode"
                                    [placeholder]="'ZIP_CODE_PLACEHOLDER' | translate"
                                    [matAutocomplete]="autoZip"
                                    (keyup)="onZipCodeChange()"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                    maxlength="5">
                                <mat-autocomplete #autoZip="matAutocomplete" (optionSelected)="onZipCodeSelected($event.option.value)">
                                    <mat-option *ngFor="let zip of filteredZipCodes" [value]="zip">
                                        {{ zip }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('zipCode')?.touched) && signUpForm.controls['zipCode'].errors?.['required']">
                                    {{'ZIP_CODE_REQUIRED' | translate}}
                                </mat-error>
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || signUpForm.get('zipCode')?.touched) && signUpForm.controls['zipCode'].errors?.['pattern']">
                                    {{'ZIP_CODE_INVALID' | translate}}
                                </mat-error>
                            </div>
                            <div class="row mb-2 mt-1">
                                <div class="col-6">
                                    <mat-label>{{ 'COUNTY'|translate }} <span class="text-danger">*</span></mat-label>
                                    <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="county" readonly>
                                </div>
                                <div class="col-6">
                                    <mat-label>{{ 'STATE'|translate }} <span class="text-danger">*</span></mat-label>
                                    <input matInput class="mat-mdc-input-element w-100 form-control" formControlName="state" readonly>
                                </div>
                            </div>
                        </div>

                        <div class="mb-2 mt-3">
                            <h6 class="fw-bold mb-2">{{ 'SECURITY_QUESTIONS'| translate}}</h6>
                            <p class="m-0 small">{{ 'INSTRUCTION_TERMS'| translate}}</p>
                            <div class="d-flex align-items-center justify-content-between w-100 gap-2 my-1">
                                <div>
                                    <mat-checkbox class="example-margin" color="primary" name="termsCheckbox"
                                        (change)="onCheckboxChange($event)">
                                    </mat-checkbox>
                                </div>
                                <div class="small">
                                    {{'CHECKBOX_TERMS' | translate}}
                                    <a class="link" (click)="openDialog('T&C')">{{ 'TERMS_OF_USE' | translate}}</a> {{
                                    'AND'| translate}} <a class="link" (click)="openDialog('PrivacyPolicy')"> {{
                                        'PRIVACY_POLICY' | translate}}</a>
                                </div>
                            </div>


                            <!-- Validation Message -->
                            <div *ngIf="!isChecked && showError" class="text-danger">
                                <mat-error class="text-danger">
                                    {{'TERMS_REQUIRED' | translate}}
                                </mat-error>
                            </div>
                        </div>

                        <button mat-flat-button color="primary" class="my-2 w-100" (click)="onContinue()" [disabled]="bothPermissionsDisabled">{{ 'CONTINUE'
                            | translate}}</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>